module.exports = __webpack_public_path__ + "static/media/add maintenance report.a0633d84.svg";